import type { IUseCase } from 'shared-kernel';
import type { IUserAdminRepository } from '../../domain/ports';

export interface VerrouillerCompteInput {
  idUtilisateur: string;
  dureeMinutes: number;
}

export class VerrouillerCompteUseCase implements IUseCase<VerrouillerCompteInput, void> {
  constructor(private readonly repository: IUserAdminRepository) {}

  async execute(input: VerrouillerCompteInput): Promise<void> {
    const response = await this.repository.verrouillerCompte(input.idUtilisateur, input.dureeMinutes);

    if (!response.succes) {
      throw new Error(response.message || 'Erreur lors du verrouillage');
    }
  }
}
